// Components
import { Section, Image } from '@tracklib/kit'
import CoverArt from 'components/coverart'
import PlayButton from 'components/playbutton'
import CenteredText from 'components/staticpages/blocks/frontpage/centeredtext'

// Hooks
import { useTheme } from 'modules/profile/hooks'

// Utils
import { createSongItemId } from 'utils'
import { CDN_ROOT } from '@constants'

import styles from './trackscarousel.css'

type InlineTrack = { id: number; image: string; override_cover?: number }

const CarouselTrack = ({ track: inlineTrack }: { track: InlineTrack }): JSX.Element | null => {
  const { id: trackId, image, override_cover } = inlineTrack
  const songItemId = createSongItemId(trackId)

  return (
    <li className={styles.carouselItem}>
      <CoverArt cover={override_cover || image} className={styles.cover} sizes="(min-width: 769px) 250px, 130px">
        <PlayButton
          className={styles.playButton}
          entity="track"
          value={{ songItemId, trackId }}
          contextKey="carouselblock"
          datatesting="songitemplaybutton"
        />
      </CoverArt>
    </li>
  )
}

type TracksCarouselProps = {
  value: {
    title: string
    label?: string
    description: string
    link_text?: string
    link_url?: string
    tracks?: Array<InlineTrack>
    background_color: string
    background_color_dark_mode?: string
    background_image: number
    background_image_dark_mode?: number
  }
}

const TracksCarousel = ({
  value: {
    title,
    label,
    description,
    link_text,
    link_url,
    tracks,
    background_color,
    background_color_dark_mode,
    background_image,
    background_image_dark_mode,
  },
}: TracksCarouselProps): JSX.Element => {
  const theme = useTheme()

  const bgImage = Image.getSrc(
    theme === 'dark' && background_image_dark_mode ? background_image_dark_mode : background_image,
    1600,
    0,
    'png',
    false,
    CDN_ROOT,
  )
  const backgroundColor = theme === 'dark' && background_color_dark_mode ? background_color_dark_mode : background_color

  return (
    <div className={styles.wrap}>
      <div className={styles.bg} style={{ backgroundColor }}>
        <div
          className={styles.separator}
          style={{
            backgroundImage: `url("${bgImage}")`,
          }}
        />
      </div>
      <Section className={styles.wrapper} contentClassName={styles.content}>
        {tracks && (
          <ol className={styles.carousel}>
            {tracks.map(track => (
              <CarouselTrack key={track.id} track={track} />
            ))}
          </ol>
        )}
        <CenteredText
          className={styles.text}
          link_url={link_url}
          link_text={link_text}
          description={description}
          title={title}
          label={label}
        />
      </Section>
    </div>
  )
}

export default TracksCarousel
